import React from "react";
import { useQueryClient } from "react-query";
import { useDispatch } from "react-redux";
import DivisionCmp from "../../components/cards/DivisionCmp";
import DividerCmp from "../../components/divider/DividerCmp";
import { WORK_FLOW_TYPE } from "../../config/cacheKey";

const _FilesStatus = ({ workFlowType, cartableData, state }: any) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  let test = queryClient.getQueryData(WORK_FLOW_TYPE)
    ? queryClient.getQueryData(WORK_FLOW_TYPE)!
    : "SupplierSettlementCartable";

  return (
    <DividerCmp
      // onClick={(item: any) => onClick(item)}
      data={cartableData}
      bgcolor="#fff"
    />
  );
};

export default function FilesStatus({
  workFlowType,
  cartableData,
  title = "  وضعیت پرونده ها ",
}: any) {
  const child = (
    <_FilesStatus workFlowType={workFlowType} cartableData={cartableData} />
  );
  return (
    <DivisionCmp
      child={child}
      // title="  وضعیت پرونده ها "
      title={title}
      marginTop={"1vh"}
      padding={".5vh"}
    />
  );
}
